import { useQueryClient } from '@tanstack/react-query';

import { getApiV1BannerQueryOptions, useDeleteApiV1BannerId } from '@/shared/api/generated';

/**
 * Hook para excluir um Banner.
 *
 * Envolve o mutation gerado pelo Kubb para `DELETE /api/v1/banner/{id}` e
 * invalida o cache da listagem após a exclusão bem-sucedida.
 *
 * @returns Mutation do TanStack Query (`mutate`, `isPending`, …)
 *
 * @example
 * ```tsx
 * const deleteBanner = useDeleteBanner();
 * deleteBanner.mutate({ id: 42 });
 * ```
 */
export function useDeleteBanner() {
  const queryClient = useQueryClient();

  return useDeleteApiV1BannerId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: getApiV1BannerQueryOptions().queryKey });
      },
    },
  });
}
